<template>
  <div class="signature-list-wrapper">
    <div class="title-graph-list">
      <span class="has-text-weight-semibold">
        {{ General.DOCUMENT.toUpperCase() }}
      </span>
      <span class="has-text-weight-semibold">{{
        General.DAYS.toUpperCase()
      }}</span>
    </div>
    <section class="signature-list">
      <template v-if="dashboardSignatureLoad">
        <div v-for="key in 10" :key="`analysis_${key}`" class="mb-10">
          <div class="is-flex is-align-items-flex-end">
            <b-skeleton height="1rem" width="100%" />
            <b-skeleton height="1rem" width="20%" position="is-right" />
          </div>
          <b-skeleton height="1rem" width="90%" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(signature, index) in getSignatureList"
          :key="index"
          :class="signature.status"
          class="item-list"
        >
          <div>
            <p class="is-size-7 has-text-weight-semibold">
              {{ signature.file_name }}
            </p>
            <p class="is-size-7">
              {{ General.ASKED_BY }}: {{ signature.user_request_name }}
            </p>
          </div>
          <div>
            <span class="is-size-5">{{ signature.days }}</span>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";

export default {
  name: "DashboardListSignature",
  props: {
    signatureList: {
      type: Array,
      required: true
    },

    dashboardSignatureLoad: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      App,
      General
    };
  },

  computed: {
    getSignatureList() {
      const list = this.signatureList
        ? this.signatureList.map(item => ({
            ...item,
            status: item.days < 10 ? "success" : "warning"
          }))
        : [];

      return list;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.signature-list-wrapper {
  .title-graph-list {
    display: flex;
    justify-content: space-between;
    background-color: $color-2;
    margin-top: 5px;
    padding: 0px 5px;
  }

  .signature-list {
    max-height: 240px;
    overflow-y: auto;
  }

  .item-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
  }

  .warning {
    color: $warning;
  }
}
</style>
